var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerIdentification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3332 3.8501L15.8332 1.3501M15.8332 1.3501L18.3332 3.8501M15.8332 1.3501V6.3501M13.3332 16.3501V15.3501C13.3332 13.95 13.3332 13.2499 13.0607 12.7151C12.821 12.2447 12.4386 11.8623 11.9681 11.6226C11.4334 11.3501 10.7333 11.3501 9.33317 11.3501H5.6665C4.26637 11.3501 3.56631 11.3501 3.03153 11.6226C2.56112 11.8623 2.17867 12.2447 1.93899 12.7151C1.6665 13.2499 1.6665 13.95 1.6665 15.3501V16.3501M10.4165 5.1001C10.4165 6.71093 9.11067 8.01676 7.49984 8.01676C5.88901 8.01676 4.58317 6.71093 4.58317 5.1001C4.58317 3.48927 5.88901 2.18343 7.49984 2.18343C9.11067 2.18343 10.4165 3.48927 10.4165 5.1001Z",
    stroke: "#1943DC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIdentification);
export default __webpack_public_path__ + "static/media/customerIdentification.24e18511891c5beef15ef12646daf0e1.svg";
export { ForwardRef as ReactComponent };